module.exports = __webpack_public_path__ + "static/media/flyerboard_icon.ebd3c66e.svg";